<template>
  <main id="ioapp-wrapper">
    <slot></slot>
  </main>
</template>

<script>
export default {};
</script>
